import { ExportField } from '../../../../utils/exportField';
import { ICustomInspectionTypeSettings } from '../../ICustomInspectionTypeSettings';

const translationNl = {
    inspectionStandard: {
        aoBasisgegevens: 'Overspanningen Basisgegevens',
    },
};

// This won't be used in English, so no need to translate it.
const translation = {
    en: translationNl,
    nl: translationNl,
};

function elementInspectionStandardDataToFieldsArray(inspectionStandardData: any) {
    const result: ExportField[] = [];

    result.push({ name: 'field1', value: inspectionStandardData?.field1, dataType: 'string' });
    result.push({ name: 'field2', value: inspectionStandardData?.field2, dataType: 'string' });
    result.push({ name: 'field3', value: inspectionStandardData?.field3, dataType: 'string' });
    result.push({ name: 'field4', value: inspectionStandardData?.field4, dataType: 'string' });

    return result;
}

function unitInspectionStandardDataToFieldsArray(inspectionStandardData: any) {
    const result: ExportField[] = [];

    result.push({ name: 'field1', value: inspectionStandardData?.field1, dataType: 'string' });
    result.push({ name: 'field2', value: inspectionStandardData?.field2, dataType: 'string' });
    result.push({ name: 'field3', value: inspectionStandardData?.field3, dataType: 'string' });
    result.push({ name: 'field4', value: inspectionStandardData?.field4, dataType: 'string' });

    return result;
}

export const aoBasisgegevensSettings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'aoBasisgegevens',
    translation,
    conditionScoreToScore: () => '0',
    conditionScoreToColorCode: () => '#ECECEC',
    canBeImported: true,
    elementInspectionStandardDataToFieldsArray,
    unitInspectionStandardDataToFieldsArray,
};
